import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import type { UploadFile, UploadProps } from "antd";
import { message } from "antd";
import { AppButton } from "components/appButton";
import { Popup } from "components/Popup";
import openLink from "assets/icons/link-open.svg";
import { useAutosizeTextArea } from "hooks/useAutoResizeTextArea";
import {
  LogoTextArea,
  LogoTextAreaWrapper,
  PopupContent,
  PopupDescription,
  PopupLink,
  PopupTitle,
} from "components/editLogoPopup/styled";
import { uploadImagePinate, compressionFile } from "utils";
import { useJettonLogo } from "hooks/useJettonLogo";
import UploadImage from "../UploadImage";

interface EditLogoPopupProps {
  showPopup: boolean;
  tokenImage: any;
  close: () => void;
  showExample?: boolean;
}

export const EditLogoPopup = ({
  showPopup,
  tokenImage,
  showExample,
  close,
}: EditLogoPopupProps) => {
  const { jettonLogo, setLogoUrl } = useJettonLogo();
  const [tempUrl, setTempUrl] = useState("");
  const [inputFocus, setInputFocus] = useState(false);
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  useAutosizeTextArea(textAreaRef.current, tempUrl);

  const handleChange = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
    const val = evt.target?.value;

    setTempUrl(val);
  };

  useEffect(() => {
    setTempUrl(jettonLogo.logoUrl);
  }, [showPopup]);

  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const handleChangeimage: UploadProps["onChange"] = ({ fileList: newFileList }) =>
    setFileList(newFileList);

  const [isLoading, setIsLoading] = useState(false);
  const updataLogoClick = async () => {
    try {
      setIsLoading(true);
      let url = tempUrl;

      if (fileList[0] && fileList[0].originFileObj) {
        const selectedFile = fileList[0].originFileObj;

        const _file = await compressionFile(selectedFile)
        if (_file.size > 1024 * 100) return message.error('图片大小不能超过100kb')
        const resu = await uploadImagePinate(_file);
        console.log(resu, "resu");
        url = resu;
      }
      setLogoUrl(url);
      setTempUrl(url);
      close();
      setIsLoading(false);
    } catch (error) {
      message.error("图片保存失败");
    }
  };

  return (
    <Popup open={showPopup} onClose={close} maxWidth={644}>
      <PopupTitle>logo编辑</PopupTitle>
      <Box sx={{ width: "100%" }}>
        <PopupContent>
          <LogoTextAreaWrapper>
            <LogoTextArea
              spellCheck={false}
              onFocus={() => setInputFocus(true)}
              onBlur={() => setInputFocus(false)}
              value={tempUrl}
              onChange={handleChange}
              ref={textAreaRef}
              rows={1}
            />
          </LogoTextAreaWrapper>
        </PopupContent>
        <PopupDescription>
          {tokenImage.description}{" "}
          {showExample && (
            <span
              onClick={() =>
                setTempUrl("https://gateway.irys.xyz/8Mb7Knrx3bk1CSJD2XfGXhN3n6fxAv96jy2uoWE6WzDw")
              }
              style={{ fontWeight: 700, cursor: "pointer" }}>
              例子
            </span>
          )}
        </PopupDescription>

        <Box mx={2} mt={!tempUrl ? 0 : 1} sx={{ marginTop: '30px' }}>
          {/* <PopupLink
            href="https://github.com/ton-blockchain/minter-contract#jetton-metadata-field-best-practices"
            target="_blank">
            Best practices for storing logo
            <img alt="Open icon" src={openLink} width={11} height={11} style={{ marginLeft: 4 }} />
          </PopupLink> */}
          <UploadImage fileList={fileList} handleChange={handleChangeimage} />
          <div>上传图片大小不能超过100KB，格式支持PNG,JPG,JPEG</div>
        </Box>
        <Box>
          <AppButton
            // disabled={!tempUrl}
            loading={isLoading}
            height={44}
            width={118}
            fontWeight={700}
            type="button"
            onClick={updataLogoClick}
            background="#0098EA">
            保存图片
          </AppButton>
        </Box>
      </Box>
    </Popup>
  );
};
